class WindowScrollPosition {

    constructor() {
        this.el = document.getElementById("top");
        this.scrollPosition = window.scrollY;

        let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

        if ( ! isIE11) {

            // Listen for new scroll events, here we debounce our `storeScroll` function
            document.addEventListener('scroll', this.debounce(this.storeScroll), {passive: true});

            // Update scroll position for first time
            this.storeScroll();
        }
    }

    // The debounce function receives our function as a parameter
    debounce = (fn) => {
        // This holds the requestAnimationFrame reference, so we can cancel it if we wish
        let frame;

        // The debounce function returns a new function that can receive a variable number of arguments
        return (...params) => {

            // If the frame variable has been defined, clear it now, and queue for next frame
            if (frame) {
                cancelAnimationFrame(frame);
            }

            // Queue our function call for the next frame
            frame = requestAnimationFrame(() => {

                // Call our function and pass any params we received
                fn(...params);
            });

        }
    }

    // Reads out the scroll position of the #main element and stores it in the data attribute,
    // so we can use it in our stylesheets
    storeScroll = () => {

        // Store scrollY as a CSS variable [Problem: this causes high CPU]
        //document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);

        // useful classes
        if (this.scrollPosition < window.scrollY) {
            document.body.classList.add("is-scrolling-down");
        } else if (this.scrollPosition > window.scrollY) {
            document.body.classList.remove("is-scrolling-down");
        }
        this.scrollPosition = window.scrollY;

        if (window.scrollY > 3) {
            document.body.classList.add("is-scrolled");
        } else if (window.scrollY < 1){
            document.body.classList.remove("is-scrolled");
        }
    }
}

export default WindowScrollPosition;